type RoomAllocation = {
  id: string;
  quantity?: number | null;
};

export const moreRoomsAvailableThanInBasket = (room: RoomAllocation, roomIdsInBasket: string[]) => {
  if (room.quantity == null) return true;
  const numRoomsOfTypeInBasket = roomIdsInBasket.filter((id) => id === room.id).length;
  return numRoomsOfTypeInBasket < room.quantity;
};
